import React from 'react';
import { Drawer } from 'antd';
import QuestionForm, { type QuestionFormSuccessPayload } from './Form';
import type { NamedFunctionTag } from '../../function-tags/hooks/useFunctionTagSuggestions';

type QuestionEditorDrawerProps = {
  open: boolean;
  questionId?: number;
  parentQuestionId?: number | null;
  referenceId?: number;
  reportFormatId?: number;
  reportAttributeId?: number;
  availableFunctionTags?: string[];
  attributeFunctionTags?: NamedFunctionTag[];
  toolFunctionTags?: NamedFunctionTag[];
  toolId?: number;
  attributeId?: number;
  onClose: () => void;
  onSuccess: (payload: QuestionFormSuccessPayload) => void;
};

export default function QuestionEditorDrawer({
  open,
  questionId,
  parentQuestionId,
  referenceId,
  reportFormatId,
  reportAttributeId,
  availableFunctionTags,
  attributeFunctionTags,
  toolFunctionTags,
  toolId,
  attributeId,
  onClose,
  onSuccess,
}: QuestionEditorDrawerProps) {
  const isTableColumnMode = parentQuestionId !== undefined && parentQuestionId !== null;
  const title = !questionId
    ? 'Soru Oluştur'
    : isTableColumnMode
      ? 'Tablo Alt Sorusu Düzenle'
      : 'Soru Düzenle';

  return (
    <Drawer open={open} onClose={onClose} destroyOnClose width={questionId ? 800 : 480} title={title}>
      <QuestionForm
        id={isTableColumnMode ? undefined : questionId}
        mode={isTableColumnMode ? 'table-column' : 'question'}
        tableQuestionId={isTableColumnMode ? parentQuestionId : undefined}
        tableColumnId={isTableColumnMode ? questionId : undefined}
        referenceId={referenceId}
        reportFormatId={reportFormatId}
        reportAttributeId={reportAttributeId}
        attributeFunctionTags={attributeFunctionTags}
        toolFunctionTags={toolFunctionTags}
        availableFunctionTags={availableFunctionTags}
        toolId={toolId}
        attributeId={attributeId}
        onSuccess={onSuccess}
      />
    </Drawer>
  );
}
